import { Navigate, generatePath } from "react-router";

import { type LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";

import { HotelSettingsHotelInfoDefaultPresenter } from "./presenter";
import { useHotelInfoQuery } from "../../model/repository/query/use-hotel-info-query";

type Props = {
	hotelID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
};

export const HotelSettingsHotelInfoDefaultContainer = ({ hotelID, activeLangCode, navigator }: Props) => {
	const { data } = useHotelInfoQuery({
		hotelID,
	});

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <HotelSettingsHotelInfoDefaultPresenter activeLangCode={activeLangCode} navigator={navigator} data={data} />;
};

HotelSettingsHotelInfoDefaultContainer.displayName = "HotelSettingsHotelInfoDefaultContainer";
